module.exports = __webpack_public_path__ + "img/ring_r_c_1_null@2x.b69cc294.png";